import React from "react";
import get from "lodash/get";
import Typography from "@mui/material/Typography";
import { useRecordContext } from "react-admin";

type Props = {
  source: string;
  label?: string;
  sortable?: boolean;
};

export const MemoField = (props: Props) => {
  const record = useRecordContext();
  const { source } = props;
  if (!record) {
    return null;
  }
  const data = get(record, source);
  if (!data || typeof data !== "string") {
    return null;
  }
  const lines = data.split("\n");
  return (
    <>
      {lines.map((line, index) => {
        if (!line) {
          return (
            <Typography key={index} variant="body2">
              &nbsp;
            </Typography>
          );
        }
        return (
          <Typography key={index} variant="body2">
            {line}
          </Typography>
        );
      })}
    </>
  );
};
